export default {
    Metadata: {
        Name: "Iif",
        Description: "Evaluates a given expression, and returns the next argument if true, the last argument if false.",
        Syntax: "Iif(expression, returnIf_True, returnIf_false)",
        Keywords: ['Logical'],
        Author: "DataVoke, Inc.",
    },
    execute(evaledExpression, trueEval, falseEval) {
        if (evaledExpression == true) {
            return trueEval;
        }
        else {
            return falseEval;
        }
    },
};

